import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { takeUntil } from 'rxjs/operators';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { sweetAlert } from 'src/app/utils/swal';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';
import { PlannerBucketsComponent } from '../trip-planner/planner-buckets/planner-buckets.component';
import { AssigTripsService } from '../assigntrips-service/assigntrips-service';
import * as moment from 'moment';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { StaffService } from '../../staffs/staff-service/staff.service';

@Component({
  selector: 'app-bucket-wrapper',
  templateUrl: './bucket-wrapper.component.html',
  styleUrls: ['./bucket-wrapper.component.css']
})
export class BucketWrapperComponent implements OnInit, OnDestroy {
  @ViewChild('bucket', { static: false }) bucket: PlannerBucketsComponent;
  wrapper = 'buckets';
  user;
  timeZone;
  todayDate;
  skip = 0;
  isShowAllTrips = false;


  constructor(
    private sharedDataService: SharedDataService,
    private levelOfServiceService: LevelOfServiceService,
    private corporateService: CorporateService,
    private serviceArea: ServiceAreasService,
    private assignTripService: AssigTripsService,
    private driverService: DriversService,
    private staffService: StaffService
  ) { }


  ngOnInit() {
    this.getUser();
  }


  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = this.user.timeZone;
        }
      });
  }

  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.bucket.getLevelOfService(data);
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.bucket.getSpaceTypes(data);
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getCorporate() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.bucket.getCorporate(data);
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getStaffList() {
    this.staffService
      .getStaffList()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.bucket.getStaffList(data);
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }
  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.bucket.getServiceAreas(data);
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  getAllTrips(payload) {
    this.assignTripService.getAssignManifestList(payload)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          data.forEach((trip) => {
              trip.isWillcall = moment(trip.scheduleTime).tz(this.timeZone).format("HHmm") == '2359';
            });
          this.bucket.getAllTrips(data);
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getDrivers(data) {
    this.driverService
      .getDrivers(data.userId, data.endPoint, true)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.bucket.getDriverList(data);
          const shifts = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          this.bucket.getShifts(shifts);
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }


  processBucket(payload) {
    this.assignTripService
      .updateTrip(payload)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.bucket.processBucket(data);
        } else if (data) {
          sweetAlert('Error', data, 'warning', 'OK');
        }
      });
  }



  ngOnDestroy(): void {
  }


}
